<template>
  <div class="nav-bar">
    <nav>
      <div class="nav-wrapper">
        <a href class="brand-logo hide-on-med-and-down">
          <img src="@/assets/images/logoDashboard.png" alt="" srcset="" />
        </a>
        <a class="brand-logo hide-on-large-only hide-on-small-only">Miconta</a>
        <a href class="hide-on-med-and-up brand-logo">{{ $route.meta.name }}</a>
        <a data-target="mobile-demo" class="sidenav-trigger">
          <i class="material-icons">menu</i>
        </a>
        <ul class="right hide-on-med-and-down">
          <li>
            <dropdown :title="userAuth.name">
              <template slot="itens-drop">
                <li
                  @click="
                    $router.push({
                      name: 'user-edit',
                      params: { id: userAuth.uuid }
                    })
                  "
                >
                  <a>Minha Conta</a>
                </li>
                <li class="divider" tabindex="-1"></li>
                <li>
                  <a @click="logout">Sair</a>
                </li>
              </template>
            </dropdown>
          </li>
        </ul>
      </div>
    </nav>

    <div class="sidenav" id="mobile-demo" style="background:#242424">
      <drawer-navigation ref="drawerRef" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Navbar",
  data: () => ({
    instance: {}
  }),
  watch: {
    $route() {
      this.instance.close();
    }
  },
  mounted() {
    this.instance = M.Sidenav.init(this.$el.querySelector(".sidenav"));
  },
  computed: {
    ...mapState("User", ["userAuth"])
  },
  methods: {
    logout() {
      this.$refs.drawerRef.logout();
    }
  },
  beforeDestroy() {
    this.instance.destroy();
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/components/variables.scss";

.nav-bar {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 999;
}
.nav-wrapper {
  background: $background-nav-bar;
  color: #fff;

  .brand-logo {
    color: #fff;
  }
  .brand-logo.hide-on-med-and-down {
    padding: 20px 32px;
    font-size: 0px !important;
    line-height: 0px !important;
  }
}
</style>
